import { ExtraOptions } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';

export const routerConfig: ExtraOptions = {
  initialNavigation: 'enabledBlocking',
  onSameUrlNavigation: 'reload',
  paramsInheritanceStrategy: 'always',
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  relativeLinkResolution: 'legacy',
  preloadingStrategy: QuicklinkStrategy,
};
